import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import FullNav from './FullNav';
import SlimNav from './SlimNav';
import { NavProps } from './interfaces';

const queryClient = new QueryClient();

export default function Nav({
  currentUser,
  isOnSubscriptionPage,
  proOfferCode,
  shouldRenderSlimNav,
  hideSubscribeButton = false,
  ...rest
}: NavProps) {
  return (
    <AppContextProvider initialCurrentUser={currentUser}>
      <QueryClientProvider client={queryClient}>
        {shouldRenderSlimNav ? (
          <SlimNav
            currentUser={currentUser}
            proOfferCode={proOfferCode}
            isOnSubscriptionPage={isOnSubscriptionPage}
            hideSubscribeButton={hideSubscribeButton}
          />
        ) : (
          <FullNav currentUser={currentUser} {...rest} />
        )}
      </QueryClientProvider>
    </AppContextProvider>
  );
}
